import { Recipient } from "../../typings/Recipient";
import { letterStore } from "src/js/stores/letter/store";
import { useSnapshot } from "valtio";

export function useActiveSiteBoundaryImageUrl() {
  const { recipients, activeRecipientId } = useSnapshot(letterStore);

  const activeRecipient = recipients?.find((recipient) => recipient._id === activeRecipientId) ?? ({} as Recipient);

  return { siteBoundaryImageUrl: activeRecipient?.siteBoundaryImageUrl };
}
